<template>
	<main class="user-levels">
		<header class="content ">
			<div class="card-header bg-1">
				<router-link
					:to="{ path: '/users'}"
					tag="button"
					class="btn btn-primary pull-right">Back</router-link>
				<h4 class="mb-0 mt-1 ml-5">User levels</h4>
				<p class="lead text-muted">Manage user level permissions</p>
			</div>
		</header>
		<div class="content row">
			<div class="col-4 border-right">
				<button class="btn btn-primary pull-right mt-2" @click="add()">+</button>
				<h5 class="py-3">Levels</h5>
				<div v-for="(level, i) in levels"
					:class="`row border-bottom py-4 px-3 levels ${level.id == selected.id ? 'active' : ''}`"
					:ref="`level${i}`"
					@click="select(level, i)"
					>
					<input type="text" v-model="level.name" @keyup.enter="store()" @blur="store()" />
					<button v-if="level.name != 'admin'" @click="destroy( level.id )" class="btn btn-light destroy">x</button>
				</div>
			</div>
			<div class="col-2 border-right">
				<h5 class="py-3">Read</h5>
				<div>
					<div class="row pt-2">
						<div class="col-auto">
							<input class="tgl tgl-light"
								id="tgl-read-all"
								ref="tgl-read-all"
								type="checkbox"
								v-model="read_all"
								@change="toggleAll($event.target.checked,'read', () => store())"
								/>
							<label class="tgl-btn tgl-btn-primary" for="tgl-read-all"></label>
						</div>
						<div class="col-auto">
							All
						</div>
					</div>
					<div v-for="field in read_fields" class="border-top pt-2 row">
						<div class="col-auto">
							<input class="tgl tgl-light"
								:id="`tgl-read-${field.id}`"
								:checked="field.can_read ? 'checked' : ''"
								type="checkbox"
								@change="toggleOne($event.target.checked,'read', field.id)"
								/>
							<label class="tgl-btn tgl-btn-primary" :for="`tgl-read-${field.id}`"></label>
						</div>
						<div class="col-auto">
							{{field.label}}
						</div>
					</div>
				</div>
			</div>
			<div class="col-2 border-right">
				<h5 class="py-3">Write</h5>
				<div>
					<div class="row pt-2">
						<div class="col-auto">
							<input class="tgl tgl-light"
								id="tgl-write-all"
								ref="tgl-write-all"
								type="checkbox"
								v-model="write_all"
								@change="toggleAll($event.target.checked,'write', () => store())"
								/>
							<label class="tgl-btn tgl-btn-primary" for="tgl-write-all"></label>
						</div>
						<div class="col-auto">
							All
						</div>
					</div>
					<div v-for="field in write_fields" class="border-top pt-2 row">
						<div class="col-auto">
							<input class="tgl tgl-light"
								:id="`tgl-write-${field.id}`"
								type="checkbox"
								@change="toggleOne($event.target.checked,'write', field.id)"
								:checked="field.can_write ? 'checked' : ''"
								/>
							<label class="tgl-btn tgl-btn-primary" :for="`tgl-write-${field.id}`"></label>
						</div>
						<div class="col-auto">
							{{field.label}}
						</div>
					</div>
				</div>
			</div>
			<div class="col-4">
				<h5 class="py-3">Features</h5>
				<div v-for="e in extras" class="border-bottom row pt-2">
					<div class="col-auto">
						<input class="tgl tgl-light"
							:id="`tgl-${e.name}`"
							type="checkbox"
							:checked="e.checked ? 'checked' : ''"
							@change="toggleExtra($event.target.checked, e.name)"
							/>
						<label class="tgl-btn tgl-btn-primary" :for="`tgl-${e.name}`"></label>
					</div>
					<div class="col-auto">
						{{e.label}}
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import _ from 'lodash';

export default {
	name: 'UserLevels',
	data: () => {
		return {
			read_fields: [],
			write_fields: [],
			extras: [
				{ 'name':'delete', 'label': 'Can delete', 'checked': false },
				{ 'name':'create', 'label': 'Can create', 'checked': false },
				{ 'name':'script', 'label': 'Can run scripts', 'checked': false },
				{ 'name':'user', 'label': 'Can edit users', 'checked': false },
				{ 'name':'remove_image', 'label': 'Can remove images', 'checked': false },
			],
			read_all: false,
			write_all: false,
			levels: [],
			selected: { 'id':null, 'name':false, 'extras': [] }
		};
	},
	mounted: function() {
		// Load fields
		this.getFields(
			// Load levels
			() => this.getLevels(
				// Select first level in set.
				() => this.select(this.levels[0],0)
			)
		);

	},
	methods: {
		add(){
			this.levels.push({'id':false, 'name': ''})
			const lastIndex = this.levels.length-1;
			this.selected = this.levels[lastIndex];
			this.$nextTick(() => this.$refs["level" + lastIndex][0].focus());

			this.read_all = true;
			this.write_all = true;
			this.toggleAll(true,'read');
			this.toggleAll(true,'write');
			this.store();
		},

		store() {
			const p = this.$Progress;
			const a = this.$axios;
			const that = this;

			const selected = this.selected;
			let name = 	this.selected.name ? this.selected.name : 'new level';
			const id = this.selected.id ? '/'+this.selected.id : '';
			const index = this.levels.findIndex( l => l.id == selected.id );

			let levelsCopy = this.levels.slice();
			let read = this.read_all == false ? '' : "-1";
			let write = this.write_all == false ? '' : "-1";
			let extra = '';

			if( !this.read_all ){
				read = this.read_fields.filter( f => f.can_read ).map( f => f.id );
				read = read.join(',');
			}
			if( !this.write_all ){
				write = this.write_fields.filter( f => f.can_write ).map( f => f.id );
				write = write.join(',');
			}
			extra = this.extras.filter( e => e.checked ).map( e => e.name );
			extra = extra.join(',');

			if( this.levels.filter( l => l.name === name ).length > 1 ){
				name = name + '-' + this.levels.length;
			}

			p.start();
			a.post(`/user/levels${id}`, {name, read, write, extra})
				.then((response) => {
					if( response.data.level.read == '-1' ){
						this.read_all = true;
						this.toggleAll( true, 'read' );
					}
					if( response.data.level.write == '-1' ){
						this.write_all = true;
						this.toggleAll( true, 'write' );
					}
					levelsCopy[index] = response.data.level;
					this.selected = response.data.level;
					this.levels = levelsCopy;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					p.finish();
				});
		},

		destroy( id = null ){
			const p = this.$Progress;
			const a = this.$axios;
			const that = this;

			if(!confirm('Remove level? Users without levels won\'t be able to login.')) return;

			p.start();
			a.delete(`/user/levels/${id}`)
				.then((response) => {
					this.levels = this.levels.filter( l => l.id != id );
					this.select(this.levels[0],0);
					this.$notify({
						group: 'main',
						title: 'Done.',
						text: 'Level removed.',
						type: 'success',
					});
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					p.finish();
				});
		},


		getFields( callback = () => {} ){
			const p = this.$Progress;
			const a = this.$axios;
			const that = this;

			p.start();
			a.get(`/fields`)
				.then((response) => {
					this.read_fields = response.data;
					this.write_fields = response.data;
					callback();
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					p.finish();
				});
		},


		getLevels( callback = () => {} ){
			const p = this.$Progress;
			const a = this.$axios;
			const that = this;

			p.start();
			a.get(`/user/levels`)
				.then((response) => {
					this.levels = response.data;
					callback();
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					p.finish();
				});

		},

		select( level, index ){
			const that = this;

			const selectSwitches = ( type, level ) => {
				let fieldsCopy = that[`${type}_fields`].slice();

				if(level[type] == '-1'){
					that[`${type}_all`] = true;
					that.toggleAll(true,type);
					return that[`${type}_fields`];
				}
				that[`${type}_all`] = false;

				const data = level[type] ? level[type].split(',') : [];

				fieldsCopy = fieldsCopy.map( f => { f[`can_${type}`] = false; return f; } )

				data.forEach( id => {
					let i = fieldsCopy.findIndex( f => f.id == parseInt(id) );
					fieldsCopy[i][`can_${type}`] = true;
				} );

				return fieldsCopy;
			}


			let extraCopy = this.extras.slice();
					extraCopy = extraCopy.map( e => { e.checked = false; return e; }  );

			if( level.extra ){

				level.extra.split(',').forEach((extra) => {
					let i = extraCopy.findIndex( e => e.name == extra );
					if(extraCopy[i])
						extraCopy[i].checked = true;
				});

			}
			this.extras = extraCopy;


			this.write_fields = selectSwitches('write', level);
			this.read_fields = selectSwitches('read', level);
			this.selected = level;
		},

		toggleOne( on = true, type = 'read', id = null ){
			let fields = this[`${type}_fields`].slice();

			let i = fields.findIndex( f => f.id == id );
			if( !on ){
				this[`${type}_all`] = false;

				fields[i][`can_${type}`] = false;
			} else {
				fields[i][`can_${type}`] = true;
			}

			this[`${type}_fields`] = fields;

			this.store();

		},

		toggleAll( on = true, type = 'read', callback = () => {} ){
			let fields = this[`${type}_fields`].slice();

			this[`${type}_fields`] = fields.map( f => {f[`can_${type}`] = on; return f;}  )

			callback()
		},


		toggleExtra( on = true, name = null ){
			let extra = this.extras.slice();

			let i = extra.findIndex( e => e.name == name );
			if( !on ){
				extra[i].checked = false;
			} else {
				extra[i].checked = true;
			}

			this.extras = extra;

			this.store();
		}
	}
};
</script>

<style scoped lang="less">
	div.levels{
		 cursor:pointer;
		 transition: background .3s ease;
		 outline: none;

		 input {
			 background: transparent;
			 border:none;
			 outline: none;
			 font-weight: normal;
		 }

		 .destroy{
			 position: absolute;
			 right: 16px;
			 margin-top: -5px;
		 }
	}
	.active{ background:#efefef; }
</style>
